import apiClient from '../../core/apiClient';
import { MarginMetricsResponse } from '../../types/api';

export const marginService = {
  getMarginMetrics: async () => {
    const response = await apiClient.get<MarginMetricsResponse>('/api/margin/metrics');
    return response.data;
  }
};
